/* eslint-disable no-undef */
/**
 * retrieves temp aws credentials (users' unique catapult id)
 * @return {string} catapult id
 */
export const catapultId = () => cb.core.iam.getTempAWSCredsSubject();

export const getMyDomain = () =>
  cb.core.utils.DeploymentProfile.iam.aws.cbAWSDomains.find(domain => domain !== 'catapult');
/**
 * retrieves an aws token for the provided domain
 * @param {string} domain dmoain name
 * @return {string} aws token
 */
export const getAWSToken = domain => cb.core.iam.getTempAWSCreds(domain || getMyDomain());

/**
 * retrieves users' current jwt token
 * @return {string} jwt token
 */

export const getJWTToken = () => cb.core.iam.getJWTToken();

/**
 * retrieves iam event bus and adds a listener for a specific event
 * @param {string} event iam event to listen for
 * @param {function} action function to be executed upon event occuring
 */
export const IAMBus = () => cb.core.iam.getEventBus();

/**************************** Session from IAM ******************************* */

/**
 * retrieves current users' authentication status
 * @return {boolean} denotes if user is authenticated
 */
export const isLoggedIn = () => cb.core.iam.getAuthSession().isLoggedIn;

/**
 * retrieves current users' first name
 * @return {string} first name
 */
export const basicProfile = () => cb.core.iam.getAuthSession().basicProfile;

/**
 * retrieves current users' session id
 * @return {string} session id
 */
export const sessionId = () => cb.core.iam.getAuthSession().sessionId;
